// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Pokušajte ponovo i ceo datum, ovako: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Grupa',
  chart_labelSeries: () => 'Serija',
  chart_labelValue: () => 'Vrednost',
  checkboxSet_requiredMessageDetail: () => 'Obavezno',
  checkbox_requiredMessageDetail: () => 'Obavezno',
  close: () => 'Zatvori',
  collection_noData: () => 'Nema podataka za prikaz.',
  collection_selectAllRows: () => 'Izaberi sve redove',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Izaberite red ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Ne može da se sortira',
  collection_sortEnabled: () => 'Može da se sortira',
  confirmation: () => 'Potvrda',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' od ' + p['totalCount'],
  dataVisualization_noData: () => 'Nema podataka za prikaz',
  dataVisualization_stateSelected: () => 'Izabrano',
  dataVisualization_stateUnselected: () => 'Neizabrano',
  error: () => 'Greška',
  expandableList_expandCollapseInstructionText: () =>
    'Koristite strelice da biste proširivali i skupljali',
  expandableList_groupCollapse: () => 'Skupljeno',
  expandableList_groupExpand: () => 'Prošireno',
  filePicker_addFiles: () => 'Dodaj datoteke',
  filePicker_dropzonePrimaryText: () => 'Prevucite i otpustite',
  filePicker_dropzoneSecondaryText: () => 'Izaberite datoteku ili je otpustite ovde',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Izaberite ili prevucite datoteke ovde',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ne možete da otpremate datoteke tipa: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Otpremajte jednu po jednu datoteku',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ne možete da otpremate datoteke tipa ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'nepoznato',
  formControl_clear: () => 'Obriši',
  formControl_day: () => 'Dan',
  formControl_helpAvailable: () => 'Pomoć je dostupna',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Dostigli ste ograničenje od ' +
    ((
      {
        one: '1 znaka',
        few: new Intl.NumberFormat('sr-Latn').format(p['CHARACTER_LIMIT']) + ' znaka'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('sr-Latn').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('sr-Latn').format(p['CHARACTER_LIMIT']) + ' znakova') +
    '.',
  formControl_loading: () => 'Učitava se',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimalna dužina od ' + p['MAX_LENGTH'] + ' je premašena.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Preostali broj znakova je ' + p['CHARACTER_COUNT'] + '.',
  formControl_month: () => 'Mesec',
  formControl_readOnly: () => 'Samo za čitanje',
  formControl_requiredMessageDetail: () => 'Unesite vrednost.',
  formControl_year: () => 'Godina',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Kraj',
  gantt_labelLabel: () => 'Oznaka',
  gantt_labelRow: () => 'Red',
  gantt_labelStart: () => 'Početak',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nisu pronađeni odeljci koji se podudaraju.',
  indexer_keyboardInstructionText: () => "Pritisnite 'enter' da biste izabrali vrednost.",
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Između ' + p['FROM_SECTION'] + ' i ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dvaput dodirnite i zadržite da biste prešli na režim gestikulacije, a zatim prevucite nagore ili nadole da biste prilagodili vrednost.',
  info: () => 'Informacije',
  inputDateMask_date_cleared: () => 'Datum je obrisan',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Prazno',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'gggg',
  inputNumber_converterParseError: () => 'Unesite broj.',
  inputNumber_decrease: () => 'Smanji',
  inputNumber_increase: () => 'Povećaj',
  inputPassword_hidden: () => 'Lozinka je skrivena',
  inputPassword_hide: () => 'Sakrij lozinku',
  inputPassword_show: () => 'Prikaži lozinku',
  list_suggestion: () => 'Predlog',
  messageToast_allMessagesClosed: () => 'Sve iskačuće poruke su zatvorene.',
  message_close: () => 'Zatvori',
  message_confirmation: () => 'Uspešno',
  message_error: () => 'Greška',
  message_info: () => 'Informacije',
  message_navigationFromMessagesRegion: () =>
    'Prelazak na oblast za poruke. Pritisnite F6 da biste se vratili na element koji je pre toga bio u fokusu.',
  message_navigationToMessagesRegion: () =>
    'Oblast za poruke sadrži nove poruke. Pritisnite F6 da biste prešli na region najnovije poruke.',
  message_warning: () => 'Upozorenje',
  noData_message: () => 'Nema stavki za prikaz',
  overflowItemLabel: () => 'Još kartica',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'U toku',
  radio_helpForRadio: () => 'Pomoć za radio dugme',
  radio_requiredMessageDetail: () => 'Izaberite vrednost.',
  selectMultiple_apply: () => 'Primeni',
  selectMultiple_back: () => 'Nazad',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pritisnite tastere Backspace ili Delete da biste uklonili izabranu vrednost.',
  selectMultiple_selectedValues: () => 'Izabrane vrednosti',
  selectMultiple_showSelectedValues: () => 'Prikazuju se samo izabrane vrednosti.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Izabranih vrednosti: ' + p['VALUE_COUNT'] + ' .',
  select_addToList: () => 'Dodaj na listu',
  select_addToListAvailable: () => 'Dodavanje na listu je dostupno',
  select_moreSearchOptions: () => 'Više opcija pretraživanja',
  select_moreSearchOptionsAvailable: () => 'Više opcija pretraživanja je dostupno',
  select_noMatchesFound: () => 'Nije pronađen nijedan pogodak.',
  select_oneMatchFound: () => 'Pronađen je jedan rezultat',
  select_requiredMessageDetail: () => 'Izaberite vrednost.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađenih podudaranja: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađenih podudaranja: ' + p['TOTAL_SIZE'] + ' ili više',
  selector_selected: () => 'Polje za potvrdu je označeno',
  selector_unselected: () => 'Polje za potvrdu nije označeno',
  tabBarNavigationList_removeCueText: () => 'Može da se ukloni',
  timeComponent_tooltipZoomIn: () => 'Uvećaj',
  timeComponent_tooltipZoomOut: () => 'Umanji',
  train_current: () => 'Trenutno',
  train_message_type: () => 'Tip poruke',
  train_not_visited: () => 'Nije posećeno',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Korak ' + p['currentStep'] + ' od ' + p['numberOfSteps'],
  train_visited: () => 'Posećeno',
  userAssistance_learnMore: () => 'Saznajte više',
  userAssistance_required: () => 'Obavezno',
  viz_drillable: () => 'Može da se detaljno analizira',
  warn: () => 'Upozorenje'
};
export default bundle;
